import { Injectable } from '@angular/core';
import { AbstractControl, FormArray, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';

@Injectable()
export class ProductServiceProvider {
  private productSubscription: Subscription;

  watchProduct(productControl: AbstractControl) {
    if (!productControl) return;
    if (!this.productSubscription) {
      this.productSubscription = productControl.valueChanges.subscribe(() => this.toggleCementDisplay(productControl));
    }
  }

  public toggleCementDisplay(productControl: AbstractControl) {
    this.addInfoDiv();

    const productName = (productControl && productControl.value[0].name) || '';
    if (productName.toLocaleLowerCase() === 'beton') {
      this.recalculateProductAmount(productControl.value[0].volume);
      this.lockUnitAtM3(productControl);
    } else {
      const productDiv: HTMLDivElement = document.getElementById('product') as HTMLDivElement;
      const infoDiv = productDiv && (productDiv.getElementsByClassName('info')[0] as HTMLDivElement);
      if (infoDiv) infoDiv.hidden = true;

      this.unlockUnit(productControl);
    }
  }

  public unsubscribe() {
    this.productSubscription.unsubscribe();
    this.productSubscription = undefined;
  }

  private addInfoDiv(): HTMLDivElement {
    const infoDiv: HTMLDivElement = document.createElement('div');
    infoDiv.classList.add('info');
    infoDiv.hidden = true;
    const productDiv: HTMLDivElement = document.getElementById('product') as HTMLDivElement;

    if (productDiv && !productDiv.getElementsByClassName('info').length) {
      productDiv.appendChild(infoDiv);
    }

    return infoDiv;
  }

  private recalculateProductAmount(volume: number) {
    const text = `około ${Math.round(volume / 3)} ton cementu`;
    const productDiv: HTMLDivElement = document.getElementById('product') as HTMLDivElement;
    const infoDiv = productDiv.getElementsByClassName('info')[0] as HTMLDivElement;
    infoDiv.innerText = text;
    infoDiv.hidden = false;
  }

  private lockUnitAtM3(productControl: AbstractControl) {
    const unitInput = ((productControl as FormArray).controls[0] as FormGroup).controls['unit'];

    if (!unitInput.value || (unitInput.value && unitInput.value.name !== 'm3')) {
      unitInput.patchValue(
        {
          deleted: false,
          dictionaryDefinitionId: 8,
          id: 18,
          name: 'm3',
        },
        { onlySelf: true },
      );
      unitInput.markAsUntouched();
    }

    if (unitInput.enabled) {
      unitInput.disable({ onlySelf: true });
    }
  }

  private unlockUnit(productControl: AbstractControl) {
    const controlArray = productControl as FormArray;
    const unitInput = controlArray && (controlArray.controls[0] as FormGroup).controls['unit'];

    if (unitInput && unitInput.disabled) {
      unitInput.enable({ onlySelf: true });
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/projects/services/product-service.ts